import axios from '../axios'
import Vue from 'vue'
// 添加文件或文件夹
export const addFile = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/webfile',
    method: 'post',
    data
  })
}

export const getReadGroupFileList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/readgroupcloud',
    method: 'get',
    params: data
  })
}

// 获取文件列表
export const getFileList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/webfile',
    method: 'get',
    params: data
  })
}

// 删除文件
export const delFile = data => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/webfile',
    method: 'delete',
    params: data
  })
}

// 修改文件
export const modifyFile = data => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/webfile',
    method: 'patch',
    params: data
  })
}

// 移动文件
export const moveFile = data => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/move',
    method: 'patch',
    params: data
  })
}

// 搜索文件
export const getFileListBySearch = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/search',
    method: 'get',
    params: data
  })
}

// 查找文件父级
export const getFileParentList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/parentlist',
    method: 'get',
    params: data
  })
}

// 上传文件（校验md5）
export const checkFileMd5 = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskUploadServer + '/preupload',
    method: 'get',
    params: data
  })
}

// 上传文件
export const uploadFile = data => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskUploadServer + '/webupload',
    method: 'post',
    data
  })
}

export const getUploadStatus = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskUploadServer + '/uploadstatus',
    method: 'get',
    params: data
  })
}

// 获取上传
export const getAliCloudUploadToken = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/mediaupload',
    method: 'get',
    params: data
  })
}
// 上传完成获取Url
export const getMediaUrl = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cloudDiskServer + '/mediaurlrq',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/cloudDisk.js